"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const Badge_1 = __importDefault(require("../Badge"));
const TabTitle = props => {
  const {
    title,
    onSelect,
    isSelected,
    tabIndex,
    badgeValue,
    bgColor,
    name,
    badgeProps,
    mobile
  } = props;
  const onClick = () => {
    if (isSelected) {
      return;
    }
    onSelect(tabIndex);
  };
  return (0, jsx_runtime_1.jsx)(styles_1.StyledTabListItem, {
    isSelected: isSelected,
    bgColor: bgColor,
    "aria-selected": isSelected,
    "aria-label": name,
    mobile: mobile,
    onClick: onClick,
    children: (0, jsx_runtime_1.jsxs)(styles_1.StyledTabTitle, {
      isSelected: isSelected,
      bgColor: bgColor,
      mobile: mobile,
      children: [title, (0, jsx_runtime_1.jsx)(styles_1.StyledTabBadge, {
        badgeValue: badgeValue,
        children: (0, jsx_runtime_1.jsx)(Badge_1.default, {
          altColors: true,
          isActive: isSelected,
          ...badgeProps,
          children: badgeValue
        })
      })]
    })
  });
};
exports.default = TabTitle;